import axios from "axios";
import { BASE_URL } from "./contexts/UserContext";


export const followUnFollowUser = async (userId) => {


  try {
    const { data } = await axios.put(
      `${BASE_URL}/users/update/follow-unfollow/${userId}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }

      
      );
      return data
  } catch (error) {
    console.log(error)
  }
};
